'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapIcon = function MapIcon(props) {
    return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', width: '12', height: '18', viewBox: '0 0 12 18' },
        _react2.default.createElement(
            'g',
            { fillRule: 'evenodd' },
            _react2.default.createElement('path', { fill: props.color, d: 'M.611 16L11.388 16C11.726 16 12 16.273 12 16.611L12 17.389C12 17.727 11.726 18 11.388 18L.611 18C.273 18 0 17.727 0 17.389L0 16.611C0 16.273.273 16 .611 16M9.131 3.613C9.046 3.85 8.962 4.088 8.877 4.325 8.721 4.812 8.508 5.514 8.202 6.754L8.006 7.572C7.982 7.675 7.957 7.78 7.933 7.889 7.85 8.25 7.699 8.808 7.65 9.011 7.575 9.332 7.488 9.52 7.154 9.619 7.154 9.619 6.981 9.677 6.771 9.646 6.318 9.581 6.296 9.227 6.221 8.94 6.107 8.502 5.984 7.428 5.968 6.806 5.967 6.742 5.965 6.678 5.964 6.615L5.961 6.552C5.96 6.52 5.957 6.505 5.955 6.496 5.95 6.476 5.938 6.469 5.915 6.475 5.894 6.481 5.878 6.504 5.845 6.593 5.788 6.769 5.684 7.109 5.604 7.411 5.465 7.921 5.302 8.508 5.231 8.839 5.149 9.15 5.068 9.46 4.987 9.77 4.924 10.049 4.637 10.225 4.447 10.274 4.24 10.327 4.12 10.336 3.963 10.297 3.752 10.245 3.63 9.984 3.568 9.75 3.533 9.619 3.469 9.376 3.444 9.078 3.396 8.485 3.374 8.069 3.392 7.469 3.409 6.775 3.479 5.759 3.526 5.196 3.533 5.009 3.541 4.822 3.55 4.636 3.55 4.427 3.537 4.299 3.511 4.205 3.488 4.126 3.46 4.082 3.404 4.004 3.386 3.977 3.367 3.96 3.361 3.941 3.329 3.821 3.603 3.599 3.968 3.518 4.195 3.468 4.392 3.458 4.554 3.596 4.656 3.71 4.672 3.821 4.666 4.051 4.663 4.129 4.653 4.243 4.644 4.353 4.615 4.714 4.52 5.346 4.491 5.708 4.443 6.209 4.391 6.769 4.378 7.285 4.373 7.537 4.369 8.018 4.389 8.093 4.4 8.131 4.417 8.156 4.449 8.147 4.481 8.139 4.497 8.114 4.544 7.99 4.558 7.939 4.571 7.889 4.584 7.839 4.598 7.787 4.61 7.737 4.624 7.687 4.624 7.687 4.839 6.954 5.02 6.356 5.214 5.778 5.409 5.183 5.538 4.848 5.73 4.354 5.826 3.991 6.157 3.909 6.488 3.828 6.792 3.97 6.855 4.209 6.886 4.333 6.887 4.41 6.873 4.892 6.85 5.737 6.904 6.404 6.925 7.048 6.943 7.327 6.965 7.545 6.993 7.651 7.005 7.698 7.031 7.713 7.053 7.708 7.095 7.698 7.11 7.665 7.136 7.548 7.147 7.491 7.158 7.435 7.17 7.378 7.248 7.001 7.326 6.624 7.404 6.248 7.585 5.422 7.711 4.934 7.934 4.169 8.197 3.261 8.393 2.848 8.725 2.777 9.037 2.709 9.214 2.961 9.231 3.21 9.236 3.294 9.197 3.478 9.131 3.613M5.999 0C2.821 0 0 2.515 0 5.615 0 5.856.021 6.085.05 6.316.541 10.698 5.628 15.756 5.628 15.756 5.715 15.849 5.794 15.908 5.875 15.951L5.88 15.951 6.04 16 6.201 15.951 6.205 15.951C6.285 15.908 6.37 15.849 6.456 15.756 6.456 15.756 11.474 10.694 11.955 6.305 11.98 6.08 12 5.851 12 5.615 12 2.515 9.179 0 5.999 0' })
        )
    );
};

MapIcon.propTypes = {
    color: _propTypes2.default.string
};

MapIcon.defaultProps = {
    color: '#fff'
};

exports.default = MapIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/Icons/MapIcon/index.js
// module id = 803
// module chunks = 0